export const URL_ADJUNTOS =
  'https://sistemasmvla.com.ar:8443/municipalidad/ws/municipalidad/downloadArchivoAppTurismo';
